import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

const GlobalStyle = createGlobalStyle`
  html, body {
    background: ${theme.bg};
  }
  body {
    font-family: ${theme.fontHeading};
    color: ${theme.text};
  }
  a {
    color: ${theme.accent};
    text-decoration: none;
  }
  ::selection {
    background: ${theme.accent};
    color: ${theme.bg};
  }

  @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pulse { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.4; transform: scale(0.85); } }
  @keyframes blink { 0%, 49% { opacity: 1; } 50%, 100% { opacity: 0; } }
  @keyframes drift { 0% { transform: rotate(-8deg) translateY(0px); } 50% { transform: rotate(-6deg) translateY(-10px); } 100% { transform: rotate(-8deg) translateY(0px); } }
  @keyframes driftSlow { 0% { transform: rotate(4deg) translateY(0px); } 50% { transform: rotate(6deg) translateY(14px); } 100% { transform: rotate(4deg) translateY(0px); } }
  @keyframes spinSlow { from { transform: rotate(-8deg); } to { transform: rotate(352deg); } }
  @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
  @keyframes bounce { 0%, 100% { transform: translateY(0); opacity: 0.5; } 50% { transform: translateY(10px); opacity: 1; } }
  @keyframes shimmer { 0%, 100% { opacity: 1; } 50% { opacity: 0.55; } }
`;

export default GlobalStyle;
